import React from 'react';
import { normalizePluBalanza } from '../../../utils/balanza/pluBalanza';

const HELP_TEXT = 'Utilizado para etiquetas de balanzas Kretz y compatibles.';

/**
 * Campo opcional PLU de balanza (5 dígitos normalizados al guardar / blur).
 */
export default function PluBalanzaField({
  value = '',
  onChange,
  onBlur,
  className = 'nexo-field',
  labelClassName = 'block text-sm font-medium text-e0e3-muted mb-1',
  showNormalizedHint = true
}) {
  const normalizedPreview = normalizePluBalanza(value);
  const showPreview = showNormalizedHint && String(value || '').trim() && normalizedPreview;

  return (
    <div>
      <label className={labelClassName}>
        PLU de balanza
      </label>
      <input
        type="text"
        name="pluBalanza"
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        className={className}
        placeholder="Ej: 36 → 00036"
        inputMode="numeric"
        autoComplete="off"
        maxLength={5}
      />
      <p className="mt-1 text-xs text-e0e3-muted">{HELP_TEXT}</p>
      {showPreview && (
        <p className="mt-1 text-xs font-medium text-e0e3-accent">
          PLU: {normalizedPreview}
        </p>
      )}
    </div>
  );
}

export { HELP_TEXT as PLU_BALANZA_HELP_TEXT };
